export default "__VITE_ASSET__BMv6eQFM__"